const excelMaxNum = 10000;
export default {
  role: {
    boss: 1,
    employee: 2,
    manager: 3,
  },
  excel: {
    maxNum: excelMaxNum,
    tip: `单次最多导出${excelMaxNum}条数据`,
  },
};
